import { SVGProps, Ref, forwardRef } from 'react';

export const ImageHyperstarOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8 .5c6.563 0 7.5.938 7.5 7.5s-.937 7.5-7.5 7.5S.5 14.563.5 8q0-.616.012-1.167h1.401Q1.9 7.373 1.9 8c0 .782.014 1.46.046 2.05l3.618-2.948 3.646 2.86 2.436-1.915 2.409 1.99c.032-.588.045-1.261.045-2.037 0-1.63-.06-2.808-.225-3.682-.162-.86-.4-1.285-.654-1.539-.254-.253-.68-.492-1.54-.654C10.809 1.96 9.63 1.9 8 1.9q-.626 0-1.167.012v-1.4Q7.384.499 8 .5M2.13 11.707c.162.842.398 1.263.65 1.514.253.253.679.492 1.538.654.874.165 2.052.225 3.682.225s2.808-.06 3.682-.225c.86-.162 1.285-.4 1.539-.654.251-.252.488-.673.65-1.52l-2.247-1.856-2.413 1.896-3.629-2.846z"
                        fill="currentColor"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.331 3.132c.606 0 1.11.21 1.448.617.32.384.418.854.418 1.25s-.098.866-.418 1.25c-.338.406-.843.616-1.448.616-.606 0-1.11-.21-1.45-.616-.319-.384-.417-.854-.417-1.25s.098-.866.418-1.25c.338-.406.843-.617 1.45-.617m0 1.4c-.269 0-.348.081-.374.113-.045.053-.093.166-.093.354s.048.3.093.354c.026.03.105.112.374.112s.347-.081.373-.112c.045-.054.093-.167.093-.354 0-.188-.048-.3-.093-.354-.026-.032-.105-.113-.373-.113"
                        fill="currentColor"
                    />
                    <path
                        d="M3 .5A9.5 9.5 0 0 0 5.5 3 9.5 9.5 0 0 0 3 5.5 9.5 9.5 0 0 0 .5 3 9.5 9.5 0 0 0 3 .5"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
ImageHyperstarOutlinedSize16Glyph.displayName = 'ImageHyperstarOutlinedSize16Glyph';
